import React, { useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import GetAppIcon from '@material-ui/icons/GetApp';
import useStyles from './Styles/StagingStyles';
import DocuwareTemplateService from '../../../services/DocuwareTemplateService';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PDFViewer = ({ file, name, extension }) => {
  const classes = useStyles();
  const [numPages, setNumPages] = useState(null);
  const [scale, setScale] = useState(1.0);
  const [fileData, setFileData] = useState(null);
  const [failed, setFailed] = useState(false);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const zoomIn = () => setScale((prev) => Math.min(prev + 0.2, 2));
  const zoomOut = () => setScale((prev) => Math.max(prev - 0.2, 0.7));

  const handleDownload = () => {
    if (!fileData) return;

    const url = fileData;
    const link = document.createElement('a');
    link.href = url;
    link.download = name || 'document.pdf';
    URL.revokeObjectURL(url);
    link.click();
  };

  useEffect(() => {
    if (!file) return;
    setFileData(null);
    setFailed(false);
    DocuwareTemplateService.viewDocument(file)
    .then((response) => {
      console.log('Blob response:', response.data);
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(blob);
      setFileData(fileURL);
    })
    .catch((error) => {
      console.error('Failed to fetch document:', error);
      setFailed(true);
    });
  }, [file]);

  if (extension.toLowerCase() !== '.pdf') {
    return (
      <div className={classes.unsupportedPreviewContainer}>
        <div className={classes.unsupportedMessage}>
          <h2>Unsupported file format. File cannot be previewed.</h2>
          <button onClick={handleDownload} className={classes.downloadButton}>
            Download File
          </button>
        </div>
      </div>
    );
  }

  if (failed){
    return (
      <div className={classes.unsupportedPreviewContainer}>
        <div className={classes.unsupportedMessage}>
          <h2>Error occured while fetching the document. Failed to preview the file.</h2>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.pdfViewerContainer}>
      <div className={classes.pdfToolbar}>
        <button onClick={zoomOut}>➖ Zoom Out</button>
        <span>Zoom: {(scale * 100).toFixed(0)}%</span>
        <button onClick={zoomIn}>➕ Zoom In</button>
        {numPages && (
          <span className={classes.pageCount} style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', marginLeft: 'auto' }}>
            <GetAppIcon
              onClick={handleDownload}
              titleAccess="Download PDF"
              style={{ cursor: 'pointer', color: 'inherit', marginRight: '10px' }}
            />
            Pages: {numPages}
          </span>
        )}
      </div>

      <div className={classes.pdfScrollArea}>
        <div className={classes.pdfContentWrapper}>
          {fileData ? (
            <Document
              file={fileData}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={(error) => console.error('PDF load error:', error)}
            >
              {Array.from(new Array(numPages), (_, index) => (
                <Page key={`page_${index + 1}`} pageNumber={index + 1} scale={scale} />
              ))}
            </Document>
          ) : (
            <div>Loading PDF...</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PDFViewer;
